import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import TouchableWithoutFeedback from "react-native-web/dist/exports/TouchableWithoutFeedback";
import Text from "react-native-web/dist/exports/Text";
import View from "react-native-web/dist/exports/View";
import { shouldUpdate } from "../../../component-updater";
import Dot from "../../dot";
import * as defaultStyle from "../../../style";
import styleConstructor from "./style";
import { jsx as ___EmotionJSX } from "@emotion/core";

var Day = function (_Component) {
  _inherits(Day, _Component);

  var _super = _createSuper(Day);

  function Day(props) {
    var _this;

    _classCallCheck(this, Day);

    _this = _super.call(this, props);
    _this.theme = _objectSpread({}, defaultStyle, {}, props.theme || {});
    _this.style = styleConstructor(props.theme);
    _this.markingStyle = _this.getDrawingStyle(props.marking || []);
    _this.onDayPress = _this.onDayPress.bind(_assertThisInitialized(_this));
    _this.onDayLongPress = _this.onDayLongPress.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Day, [{
    key: "onDayPress",
    value: function onDayPress() {
      this.props.onPress(this.props.date);
    }
  }, {
    key: "onDayLongPress",
    value: function onDayLongPress() {
      this.props.onLongPress(this.props.date);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var newMarkingStyle = this.getDrawingStyle(nextProps.marking);

      if (!_.isEqual(this.markingStyle, newMarkingStyle)) {
        this.markingStyle = newMarkingStyle;
        return true;
      }

      return shouldUpdate(this.props, nextProps, ['state', 'children', 'onPress', 'onLongPress']);
    }
  }, {
    key: "getDrawingStyle",
    value: function getDrawingStyle(marking) {
      var _this2 = this;

      var defaultStyle = {
        textStyle: {},
        containerStyle: {}
      };

      if (!marking) {
        return defaultStyle;
      }

      if (marking.disabled) {
        defaultStyle.textStyle.color = this.theme.textDisabledColor;
      } else if (marking.selected) {
        defaultStyle.textStyle.color = this.theme.selectedDayTextColor;
      }

      var resultStyle = [marking].reduce(function (prev, next) {
        if (next.quickAction) {
          if (next.first || next.last) {
            prev.containerStyle = _this2.style.firstQuickAction;
            prev.textStyle = _this2.style.firstQuickActionText;

            if (next.endSelected && next.first && !next.last) {
              prev.rightFillerStyle = '#c1e4fe';
            } else if (next.endSelected && next.last && !next.first) {
              prev.leftFillerStyle = '#c1e4fe';
            }
          } else if (!next.endSelected) {
            prev.containerStyle = _this2.style.quickAction;
            prev.textStyle = _this2.style.quickActionText;
          } else if (next.endSelected) {
            prev.leftFillerStyle = '#c1e4fe';
            prev.rightFillerStyle = '#c1e4fe';
          }

          return prev;
        }

        var color = next.color;

        if (next.status === 'NotAvailable') {
          prev.textStyle = _this2.style.naText;
        }

        if (next.startingDay) {
          prev.startingDay = {
            color: color
          };
        }

        if (next.endingDay) {
          prev.endingDay = {
            color: color
          };
        }

        if (!next.startingDay && !next.endingDay) {
          prev.day = {
            color: color
          };
        }

        if (next.textColor) {
          prev.textStyle.color = next.textColor;
        }

        if (marking.customTextStyle) {
          defaultStyle.textStyle = marking.customTextStyle;
        }

        if (marking.customContainerStyle) {
          defaultStyle.containerStyle = marking.customContainerStyle;
        }

        return prev;
      }, defaultStyle);
      return resultStyle;
    }
  }, {
    key: "render",
    value: function render() {
      var containerStyle = [this.style.base];
      var textStyle = [this.style.text];
      var leftFillerStyle = {};
      var rightFillerStyle = {};
      var fillerStyle = {};
      var fillers;

      if (this.props.state === 'disabled') {
        textStyle.push(this.style.disabledText);
      } else if (this.props.state === 'today') {
        containerStyle.push(this.style.today);
        textStyle.push(this.style.todayText);
      }

      if (this.props.marking) {
        containerStyle.push({
          borderRadius: 17
        });
        var flags = this.markingStyle;

        if (flags.textStyle) {
          textStyle.push(flags.textStyle);
        }

        if (flags.containerStyle) {
          containerStyle.push(flags.containerStyle);
        }

        if (flags.leftFillerStyle) {
          leftFillerStyle.backgroundColor = flags.leftFillerStyle;
        }

        if (flags.rightFillerStyle) {
          rightFillerStyle.backgroundColor = flags.rightFillerStyle;
        }

        if (flags.startingDay && !flags.endingDay) {
          leftFillerStyle = {
            backgroundColor: this.theme.calendarBackground
          };
          rightFillerStyle = {
            backgroundColor: flags.startingDay.color
          };
          containerStyle.push({
            backgroundColor: flags.startingDay.color
          });
        } else if (flags.endingDay && !flags.startingDay) {
          rightFillerStyle = {
            backgroundColor: this.theme.calendarBackground
          };
          leftFillerStyle = {
            backgroundColor: flags.endingDay.color
          };
          containerStyle.push({
            backgroundColor: flags.endingDay.color
          });
        } else if (flags.day) {
          leftFillerStyle = {
            backgroundColor: flags.day.color
          };
          rightFillerStyle = {
            backgroundColor: flags.day.color
          };
          fillerStyle = {
            backgroundColor: flags.day.color
          };
        } else if (flags.endingDay && flags.startingDay) {
          rightFillerStyle = {
            backgroundColor: this.theme.calendarBackground
          };
          leftFillerStyle = {
            backgroundColor: this.theme.calendarBackground
          };
          containerStyle.push({
            backgroundColor: flags.endingDay.color
          });
        }

        fillers = ___EmotionJSX(View, {
          style: [this.style.fillers, fillerStyle]
        }, ___EmotionJSX(View, {
          style: [this.style.leftFiller, leftFillerStyle]
        }), ___EmotionJSX(View, {
          style: [this.style.rightFiller, rightFillerStyle]
        }));
      }

      var _this$props = this.props,
          _this$props$marking = _this$props.marking,
          marked = _this$props$marking.marked,
          dotColor = _this$props$marking.dotColor,
          theme = _this$props.theme;
      return ___EmotionJSX(TouchableWithoutFeedback, {
        testID: this.props.testID,
        onPress: this.onDayPress,
        onLongPress: this.onDayLongPress,
        disabled: this.props.marking.disableTouchEvent,
        accessible: true,
        accessibilityRole: this.props.marking.disableTouchEvent ? undefined : 'button',
        accessibilityLabel: this.props.accessibilityLabel
      }, ___EmotionJSX(View, {
        style: this.style.wrapper
      }, fillers, ___EmotionJSX(View, {
        style: containerStyle
      }, ___EmotionJSX(Text, {
        allowFontScaling: false,
        style: textStyle
      }, String(this.props.children)), ___EmotionJSX(Dot, {
        theme: theme,
        isMarked: marked,
        dotColor: dotColor
      }))));
    }
  }]);

  return Day;
}(Component);

_defineProperty(Day, "displayName", 'IGNORE');

_defineProperty(Day, "propTypes", {
  state: PropTypes.oneOf(['selected', 'disabled', 'today', '']),
  theme: PropTypes.object,
  marking: PropTypes.any,
  onPress: PropTypes.func,
  onLongPress: PropTypes.func,
  date: PropTypes.object,
  markingExists: PropTypes.bool
});

export default Day;

if (typeof Day !== 'undefined' && Day && Day === Object(Day) && Object.isExtensible(Day) && !Day.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Day, '__filemeta', {
    configurable: true,
    value: {
      name: "Day",
      filename: "node_modules/react-native-calendars/src/calendar/day/period/index.js"
    }
  });
}